var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import { useEffect } from 'react';
import { Route } from 'react-router-dom';
import propTypes from 'prop-types';
import useModalGallery from './useModalGallery';

function ModalRouteContent(_ref) {
  var defaultParentPath = _ref.defaultParentPath,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ['defaultParentPath', 'children']);

  var _useModalGallery = useModalGallery(),
      previousParentLocation = _useModalGallery.previousParentLocation;

  var location = rest.location,
      history = rest.history;


  var isModal = location.state && location.state.modal;
  var isInitialRender = previousParentLocation === location;

  // isModal: false => User opened a modal route directly (opened on a new tab etc.)
  // isInitialRender: true => User refreshed the page while on a modal route (pressed the F5 etc.)
  var reRenderRoute = !isModal || isInitialRender;

  useEffect(function () {
    function addStateToLocation() {
      history.replace(_extends({}, location, {
        state: _extends({}, location.state, {
          defaultParentPath: defaultParentPath,
          modal: true
        })
      }));
    }

    if (reRenderRoute) {
      'rerender';
      addStateToLocation();
    }
  }, [location, defaultParentPath, reRenderRoute, history]);

  return !reRenderRoute ? children(_extends({}, rest)) : null;
}

ModalRouteContent.propTypes = _extends({}, Route.propTypes, {
  defaultParentPath: propTypes.string.isRequired
});

export default ModalRouteContent;